// extracted by mini-css-extract-plugin
export default {"form":"CreateNewHandlerForm_form__qHpl6","row2":"CreateNewHandlerForm_row2__VZBSi","row3":"CreateNewHandlerForm_row3__c5moI","rowFull":"CreateNewHandlerForm_rowFull__ukA9x"};